import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static values = {
    resetPath: String,
  };

  resetFilters = () => {
    window.history.pushState({}, '', this.resetPathValue);
    this.visitUrl(new URL(this.resetPathValue, window.location.origin));
  };

  visitUrl = (url) => {
    fetch(url.toString(), {
      headers: {
        Accept: 'text/vnd.turbo-stream.html',
      },
    }).then((r) => r.text())
      .then((html) => Turbo.renderStreamMessage(html));
  };
}
